import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function TwoFADisableStep({ password, setPassword, onConfirm, onCancel, processing }) {
  return (
    <div className="space-y-4 mt-4">
      <p className="text-sm text-muted-foreground">
        Please confirm your password to disable two-factor authentication.
      </p>
      <div>
        <Label htmlFor="disable-password">Password</Label>
        <Input
          id="disable-password"
          data-testid="disable-2fa-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2"
        />
      </div>
      <div className="flex gap-3">
        <Button data-testid="disable-2fa-confirm-btn" onClick={onConfirm} disabled={processing} variant="destructive" className="flex-1 rounded-full">
          Disable 2FA
        </Button>
        <Button onClick={onCancel} variant="outline" className="flex-1 rounded-full">Cancel</Button>
      </div>
    </div>
  );
}
